

















































import { Component, Vue } from 'vue-property-decorator';
import Top from '@/components/Top.vue';
import Bottom from '@/components/Bottom.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MokYun from '@/components/MokYun.vue';
import { Api } from '@/utils/request';
Vue.use(ElementUI);
@Component({
  components: {
    MokYun,
    Bottom,
    Top,
  },
})
export default class Mokyun extends Vue {
  public menuList: any = [];
  public page = 1;
  public limit = 5;
  public type = 'center';
  public search = '';
  public currentPage = 1;
  public tableData = [];
  public pageTotal = 0;
  public level = '';
  public async created() {
    const res = await Api.Search.getPageNum({
      limit: this.limit,
      type: this.type,
      search: this.search,
      level: this.level,
    });
    this.pageTotal = Number(res);
    this.tableData = await Api.Search.getList({
      page: this.page,
      limit: this.limit,
      type: this.type,
      search: this.search,
      level: this.level,
    });
  }
  public async query() {
    this.currentPage = 1;
    this.page = 1;
    const res = await Api.Search.getPageNum({
      limit: this.limit,
      type: this.type,
      search: this.search,
      level: this.level,
    });
    this.pageTotal = Number(res);
    this.tableData = await Api.Search.getList({
      page: this.page,
      limit: this.limit,
      type: this.type,
      search: this.search,
      level: this.level,
    });
  }
  public async change(e: any) {
    this.currentPage = Number(e);
    this.page = Number(e);
    this.tableData = await Api.Search.getList({
      page: this.page,
      limit: this.limit,
      type: this.type,
      search: this.search,
      level: this.level,
    });
  }
}
